import clsx from 'clsx'
import { NavLink, type NavLinkProps } from 'react-router'

import type { IconProp } from 'slab'

interface NavItemProps extends NavLinkProps {
  children: React.ReactNode;
  icon: IconProp;
}

export function NavItem ({ children, icon: Icon, ...props }: NavItemProps) {
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        clsx(
          'block rounded-lg p-2 cursor-pointer no-underline text-current transition-colors hover:bg-gray-200 outline outline-2 outline-transparent focus-visible:outline-thatch-500',
          {
            'bg-gray-200': isActive,
          }
        )}
    >
      {({ isActive }) => (
        <div className='flex w-full justify-start items-center gap-2'>
          <Icon
            size={16}
            className={clsx('flex items-center justify-center rounded mx-2 size-4', {
              'text-thatch-500': isActive,
              'text-gray-400': !isActive,
            })}
          />
          <span className='body leading-5 text-gray-800'>{children}</span>
        </div>
      )}
    </NavLink>
  )
}
